module.exports = __webpack_public_path__ + "static/tat-26-d0020afbe3ae77f1eb834d86d4827191.jpg";